import Provider, { useSession } from './Context';

import { useCreateContext } from './hooks';

const withSessionContext = (Component) => (props) => {
  const context = useCreateContext();
  return (
    <Provider value={context}>
      <Component {...props} />
    </Provider>
  );
};

const SessionBase = withSessionContext((props) => {
  const { state, setState } = useSession();
  const Component = state.component();

  return (
    <Component
      setState={setState}
      {...props}
    />
  );
});

export default SessionBase;
